import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        //工具集用到的信息   
        currentuser: {}, // 当前登陆人的信息,
        isShowLeftMenu: false, //是否显示左侧菜单
        defaultActiveIndex: "", //左侧菜单默认选中的id
        buttons: [], // 应用主表按钮
        currentSelectMenuData: {}, //当前选中菜单信息
        detailInfo: {}, //当前应用信息
        currentMainTableJson: {},//当前应用主表json
        currentDetailPageJson: {}, //当前应用详情json
        currentDetailTabsModel: "", //当前详情页tabs默认选中
        jsonData: {},//当前应用json
        currentAppIsHasFlow: false,   //当前应用是否有流程
        currentAppIsHasReport: false, //当前应用是否有报表
        childrensInfo: {},//子表信息
        isrequestChildTableData: false, //是否请求子表数据
        isrequestChildenclosureForDetail: false, //子表请求详情数据时请求附件数据
        currentAppChildRowData: {}, //当前新建/编辑的子表的某条数据
        isCanEditDetailInfo: false, //当前应用是否编辑主表信息
        isCanEditChildInfo: false, //当前应用是否可编辑子表信息
        detailJosnArr: [],//详情页主表json
        menuAndDrawer: false, //左侧菜单以及应用详情抽屉显示状态
        updateMainTableData: false, //是否刷新列表数据
        childTableJson: [],//记录当前应用的子表json


        //版本1用到的信息
        currentShowPage: 1, //
        dataChangeStatus: 0, // 解析器  数据变化状态   0 未变化  1变化
        isSaveAllData: false, //是否保存当前数据
        validateChildFormResult: [], //当前应用子表验证结果
        istouchvalidateChild: false,//是否触发子表验证

        //--------------------转到功能用到的全局变量---------------------------
        shareDetailInfo: {},
        layerindex: 0,
        gotoNavigation: [],
        shareChildDetailInfo: {},

        isUsefalsepage: false,
        isCustomizationBringChildData:false,
        allMenuData:[],
        //应用系统用到的信息
    },
    getters: {
        //工具集用到的方法
        getcustomformDisabled: (state) => () => {
            if (JSON.stringify(state.jsonData) != "{}") {
                if (!!state.jsonData.config.formdisabledCondition) {
                    var str = state.jsonData.config.formdisabledCondition
                    var hideCondition = state.jsonData.config.formdisabledCondition
                    if (!!hideCondition) {
                        var arr = hideCondition.split('&&')
                        var Arr = arr.map((arrItem) => {
                            if (arrItem.indexOf('||') !== -1) {
                                return arrItem.split("||")
                            } else {
                                return arrItem
                            }
                        })
                        var newArr = Arr.flat(Infinity)
                        newArr.forEach((newArrItem) => {
                            if (newArrItem.indexOf('(') !== -1) {
                                newArrItem = newArrItem.substr(1, newArrItem.length)
                            } else if (newArrItem.indexOf(')') !== -1) {
                                newArrItem = newArrItem.substr(0, newArrItem.length - 1)
                            } else if (newArrItem.indexOf('!==') !== -1 && newArrItem.indexOf(':') !== -1) {
                                var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('!==') - 1)
                                var filedValue = newArrItem.substr(newArrItem.indexOf('!==') + 3, newArrItem.length)
                                if (filedValue.indexOf('currentuser:') !== -1) {
                                    filedValue = filedValue.replace(filedValue, state.currentuser[filedValue.substr(12, filedValue.length)])
                                }
                                if (state.detailInfo[Detailfiled] != filedValue) {
                                    str = str.replace(newArrItem, true)
                                } else {
                                    str = str.replace(newArrItem, false)
                                }
                            } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') !== -1) {
                                var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('=') - 1)
                                var filedValue = newArrItem.substr(newArrItem.indexOf('=') + 2, newArrItem.length)
                                if (filedValue.indexOf('currentuser:') !== -1) {
                                    filedValue = filedValue.replace(filedValue, state.currentuser[filedValue.substr(12, filedValue.length)])
                                }
                                if (!!state.detailInfo[Detailfiled] && state.detailInfo[Detailfiled] == filedValue) {
                                    str = str.replace(newArrItem, true)
                                } else {
                                    str = str.replace(newArrItem, false)
                                }
                            } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') == -1) {
                                var Detailfiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
                                var replaceStr = newArrItem.substr(newArrItem.indexOf(':'), newArrItem.length)
                                if (!!state.detailInfo[Detailfiled]) {
                                    str = str.replace(replaceStr, true)
                                } else {
                                    str = str.replace(replaceStr, false)
                                }
                            } else if (newArrItem.indexOf(':') == -1 && newArrItem.indexOf('==') !== -1) {
                                var Detailfiled = newArrItem.substr(0, newArrItem.indexOf('='))
                                var filedValue = newArrItem.substr(newArrItem.indexOf('=') + 2, newArrItem.length)
                                if (filedValue.indexOf('currentuser:') !== -1) {
                                    filedValue = filedValue.replace(filedValue, state.currentuser[filedValue.substr(12, filedValue.length)])
                                }
                                if (!!state.detailInfo[Detailfiled] && state.detailInfo[Detailfiled] == filedValue) {
                                    str = str.replace(newArrItem, true)
                                } else {
                                    str = str.replace(newArrItem, false)
                                }
                            }
                        })
                        if (str.indexOf(':') == -1) {
                            return eval(str)
                        }
                    } else {
                        return false
                    }
                }
            }
        }
    },
    mutations: {
        //工具集用到的方法

        //当前用户信息
        setCurrentuser(state, currentuser) {
            state.currentuser = currentuser
        },
        //设置左侧菜单是否显示
        setisShowLeftMenu(state, isShowLeftMenu) {
            state.isShowLeftMenu = isShowLeftMenu
        },
        //当前左侧导航选中的菜单
        setCurrentSelectMenuData(state, currentSelectMenuData) {
            state.currentSelectMenuData = currentSelectMenuData
        },
        setdefaultActiveIndex(state, defaultActiveIndex) {
            state.defaultActiveIndex = defaultActiveIndex
        },
        //当前应用的按钮
        setButtons(state, buttons) {
            state.buttons = buttons
        },
        //当前应用当前数据信息
        setDetailInfo(state, detailInfo) {
            state.detailInfo = detailInfo
        },
        //当前主表json
        setCurrentMainTableJson(state, currentMainTableJson) {
            state.currentMainTableJson = currentMainTableJson
        },
        //当前应用详情json
        setCurrentDetailPageJson(state, currentDetailPageJson) {
            state.currentDetailPageJson = currentDetailPageJson
        },
        //当前页面json
        setJsonData(state, jsonData) {
            state.jsonData = jsonData
        },
        //当前应用是否有流程
        setcurrentAppIsHasFlow(state, currentAppIsHasFlow) {
            state.currentAppIsHasFlow = currentAppIsHasFlow
        },
        //当前应用是否有报表
        setcurrentAppIsHasReport(state, currentAppIsHasReport) {
            state.currentAppIsHasReport = currentAppIsHasReport
        },
        //当前详情页tabs默认选中
        setcurrentDetailTabsModel(state, currentDetailTabsModel) {
            state.currentDetailTabsModel = currentDetailTabsModel
        },
        //当前应用的子表信息
        setchildrensInfo(state, childrensInfo) {
            state.childrensInfo = childrensInfo
        },
        //控制是否请求子表数据
        setisrequestChildTableData(state, isrequestChildTableData) {
            state.isrequestChildTableData = isrequestChildTableData
        },
        //控制子表请求详情数据时查询附件数据
        setisrequestChildenclosureForDetail(state, isrequestChildenclosureForDetail) {
            state.isrequestChildenclosureForDetail = isrequestChildenclosureForDetail
        },
        //控制是否保存当前数据
        setisSaveAllData(state, isSaveAllData) {
            state.isSaveAllData = isSaveAllData
        },
        //当前新建/编辑的子表的某条数据
        setcurrentAppChildRowData(state, currentAppChildRowData) {
            state.currentAppChildRowData = currentAppChildRowData
        },
        //当前应用是否编辑主表信息
        setisCanEditDetailInfo(state, isCanEditDetailInfo) {
            state.isCanEditDetailInfo = isCanEditDetailInfo
        },
        //当前应用是否可以编辑子表信息
        setisCanEditChildInfo(state, isCanEditChildInfo) {
            state.isCanEditChildInfo = isCanEditChildInfo
        },
        //详情页主表json
        setdetailJosnArr(state, detailJosnArr) {
            state.detailJosnArr = detailJosnArr
        },
        //左侧菜单以及应用详情抽屉显示状态
        setmenuAndDrawer(state, menuAndDrawer) {
            state.menuAndDrawer = menuAndDrawer
        },
        //是否刷新主表数据
        setupdateMainTableData(state, updateMainTableData) {
            state.updateMainTableData = updateMainTableData
        },
        //记录当前应用的子表json
        setchildTableJson(state, childTableJson) {
            state.childTableJson = childTableJson
        },
        //版本1 当前应用显示是列表还是详情
        setcurrentShowPage(state, currentShowPage) {
            state.currentShowPage = currentShowPage
        },
        //版本1 当前应用数据是否编辑
        setDataChangeStatus(state, dataChangeStatus) {
            state.dataChangeStatus = dataChangeStatus
        },
        //当前应用子表验证结果
        setvalidateChildFormResult(state, validateChildFormResult) {
            state.validateChildFormResult = validateChildFormResult
        },
        //是否触发子表验证
        setistouchvalidateChild(state, istouchvalidateChild) {
            state.istouchvalidateChild = istouchvalidateChild
        },
        setisUsefalsepage(state, isUsefalsepage) {
            state.isUsefalsepage = isUsefalsepage
        },
        setisCustomizationBringChildData(state,isCustomizationBringChildData){
            state.isCustomizationBringChildData = isCustomizationBringChildData
        },









        setallMenuData(state, allMenuData) {
            state.allMenuData = allMenuData
        },
        setSystemSetInfo(state, systemSetInfo) {
            state.systemSetInfo = systemSetInfo
        },
    },

    //应用系统方法
    actions: {
        setSystemSetInfoAct(context, systemSetInfo) {
            context.commit('setSystemSetInfo', systemSetInfo)
        },
        setisUsefalsepageAct(context, isUsefalsepage) {
            context.commit("setisUsefalsepage", isUsefalsepage);
        },
    },
    modules: {
    }
})
